import EzModalController from 'layouts/modal/modal-controller';
import events from 'lib/events';
import { triggerCustomEvent } from 'lib/helpers';
import Rails from 'rails-ujs';

export default class DownloadLimitUnconfirmedModalController extends EzModalController {
  static targets = ['resendConfirmation', 'resendConfirmationForm'];

  connect() {
    super.connect();

    triggerCustomEvent(events.three_download_limit.unconfirmed_open);
  }

  handleResentConfirmation = (event) => {
    if (event.detail[1] === 'OK') {
      this.resendConfirmationTarget.textContent = this.resendConfirmationTarget.dataset.successMessage;
    } else {
      this.resendConfirmationTarget.disabled = false;
    }
  }

  resendConfirmation = (event) => {
    event.preventDefault();
    triggerCustomEvent(events.three_download_limit.unconfirmed_send);

    this.resendConfirmationFormTarget.addEventListener('ajax:success', this.handleResentConfirmation);
    Rails.fire(this.resendConfirmationTarget.parentNode, 'submit');
    this.resendConfirmationTarget.disabled = true;
  }

  close(event) {
    if (event && (!event.keyCode && event.target !== event.currentTarget)) return;

    if (this.element.querySelector('.download-limit-form--unconfirmed-instant')) {
      Turbolinks.visit(window.location);
    }

    super.close();
  }
}
